/* eslint-disable arrow-body-style */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const ValuesAndStrategiesTab = () => {
  const { lang } = useTranslation('client')
  return (
    <Container size="sm">
      <Paper>
        {lang === 'en' ? (
          <div style={{ marginBottom: 30 }}>
            <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
              Values and Strategies
            </Text>
            <Text size="lg">
              At Infinity Medical Academy, our values are at the core of
              everything we do. They guide our actions, decisions, and
              interactions with our clients, partners, and stakeholders. Our
              values reflect our commitment to excellence, integrity, and
              innovation in the field of healthcare.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Key Values
            </Text>
            <Text size="lg">
              <span className="font-bold"> Excellence:</span> We are committed
              to excellence in everything we do. We strive to deliver
              high-quality training and educational programs that meet the
              highest standards of academic rigor and professional relevance. We
              continuously seek to improve our services, innovate our
              approaches, and exceed the expectations of our clients and
              stakeholders.
            </Text>
            <Text size="lg">
              <span className="font-bold">Integrity:</span> Integrity is the
              foundation of our organization. We conduct ourselves with honesty,
              transparency, and ethical integrity in all aspects of our
              business. We adhere to the highest ethical standards and respect
              the confidentiality, privacy, and rights of our clients, partners,
              and stakeholders.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Innovation:</span> Innovation drives
              our success and fuels our growth. We embrace creativity,
              curiosity, and forward thinking to develop innovative solutions
              that address the evolving needs of our clients and the industry.
              We encourage experimentation, collaboration, and continuous
              learning to stay ahead of the curve and remain at the forefront of
              our field.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Diversity and Inclusion:</span> We
              celebrate diversity and value the unique perspectives, talents,
              and contributions of individuals from diverse backgrounds and
              cultures. We foster an inclusive and welcoming environment where
              everyone feels respected, valued, and empowered to succeed. We
              believe that diversity enriches our organization and strengthens
              our collective impact.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Strategies
            </Text>
            <Text size="lg">
              Our strategies for achieving our mission and vision include:
            </Text>
            <Text size="lg">
              <span className="font-bold"> Strategic Partnerships:</span> We
              establish strategic partnerships with industry leaders,
              educational institutions, and other stakeholders to leverage
              expertise, resources, and networks for mutual benefit.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Continuous Improvement:</span> We
              embrace a culture of continuous improvement and innovation to
              enhance the quality, relevance, and effectiveness of our services.
              We regularly evaluate and refine our programs, processes, and
              practices to ensure they meet the evolving needs of our clients
              and stakeholders.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Client-Centric Approach:</span> We
              prioritize the needs and preferences of our clients and
              stakeholders in all our endeavors. We listen attentively to their
              feedback, concerns, and aspirations and tailor our services to
              meet their unique requirements and expectations.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Community Engagement: </span>We
              actively engage with our local and global communities to foster
              collaboration, knowledge sharing, and social impact. We contribute
              to community development initiatives, volunteer efforts, and
              philanthropic causes that align with our values and mission.
            </Text>

            <Text size="lg">
              Through our values-driven approach and strategic initiatives, we
              are committed to making a positive difference in the lives of
              individuals, organizations, and communities we serve.
            </Text>
          </div>
        ) : (
          <div style={{ marginBottom: 30 }}>
            <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
              القيم والاستراتيجيات
            </Text>
            <Text size="lg">
              في أكاديمية الطب اللانهائية، تكمن قيمنا في جوهر كل ما نقوم به.
              إنها توجه أفعالنا وقراراتنا وتفاعلاتنا مع عملائنا وشركائنا وأصحاب
              المصلحة. تعكس قيمنا التزامنا بالتميز والنزاهة والابتكار في مجال
              الرعاية الصحية.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              القيم الرئيسية
            </Text>
            <Text size="lg">
              <span className="font-bold"> التميز:</span> نحن ملتزمون بالتميز في
              كل ما نقوم به. نسعى جاهدين لتقديم تدريب عالي الجودة وبرامج تعليمية
              تلبي أعلى معايير الصرامة الأكاديمية والأهمية المهنية. نسعى
              باستمرار لتحسين خدماتنا، وابتكار منهجياتنا، وتجاوز توقعات عملائنا
              وشركائنا وأصحاب المصلحة.
            </Text>
            <Text size="lg">
              <span className="font-bold">النزاهة:</span> النزاهة هي أساس
              منظمتنا. نتصرف بأمانة وشفافية ونزاهة أخلاقية في جميع جوانب عملنا.
              نلتزم بأعلى المعايير الأخلاقية ونحترم السرية والخصوصية وحقوق
              عملائنا وشركائنا وأصحاب المصلحة.
            </Text>
            <Text size="lg">
              <span className="font-bold">الابتكار:</span> الابتكار يدفع نجاحنا
              ويغذي نمونا. نتبنى الإبداع والفضول والتفكير المستقبلي لتطوير حلول
              مبتكرة تلبي الاحتياجات المتطورة لعملائنا والصناعة. نشجع التجريب
              والتعاون والتعلم المستمر للبقاء في طليعة مجالنا.
            </Text>
            <Text size="lg">
              <span className="font-bold">التنوع والشمولية:</span> نحن نحتفل
              بالتنوع ونقدر وجهات النظر والمواهب والمساهمات الفريدة للأفراد من
              خلفيات وثقافات مختلفة. نعزز بيئة شاملة ومرحبة حيث يشعر الجميع
              بالاحترام والتقدير والتمكين للنجاح. نؤمن بأن التنوع يثري منظمتنا
              ويعزز تأثيرنا الجماعي.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              الاستراتيجيات
            </Text>
            <Text size="lg">
              تشمل استراتيجياتنا لتحقيق رسالتنا ورؤيتنا ما يلي:
            </Text>
            <Text size="lg">
              <span className="font-bold"> الشراكات الاستراتيجية:</span> نؤسس
              شراكات استراتيجية مع قادة الصناعة والمؤسسات التعليمية وأصحاب
              المصلحة الآخرين للاستفادة من الخبرات والموارد والشبكات للمنفعة
              المتبادلة.
            </Text>
            <Text size="lg">
              <span className="font-bold">التحسين المستمر:</span> نتبنى ثقافة
              التحسين المستمر والابتكار لتعزيز جودة وأهمية وفعالية خدماتنا. نقيم
              ونرتقي ببرامجنا وعملياتنا وممارساتنا بانتظام لضمان تلبية
              الاحتياجات المتطورة لعملائنا وأصحاب المصلحة.
            </Text>
            <Text size="lg">
              <span className="font-bold">التوجه المحوري نحو العميل:</span> نعطي
              أولوية لاحتياجات وتفضيلات عملائنا وأصحاب المصلحة في جميع مساعينا.
              نستمع بانتباه إلى تغذية العودة والمخاوف والتطلعات الخاصة بهم ونكيف
              خدماتنا لتلبية متطلباتهم وتوقعاتهم الفريدة.
            </Text>
            <Text size="lg">
              <span className="font-bold">المشاركة المجتمعية: </span>نشارك بنشاط
              مع مجتمعاتنا المحلية والعالمية لتعزيز التعاون وتبادل المعرفة
              والتأثير الاجتماعي. نساهم في مبادرات تطوير المجتمع وجهود التطوع
              والقضايا الخيرية التي تتماشى مع قيمنا ورسالتنا.
            </Text>

            <Text size="lg">
              من خلال نهجنا القائم على القيم والمبادرات الاستراتيجية، نلتزم
              بتحقيق فارق إيجابي في حياة الأفراد والمنظمات والمجتمعات التي
              نخدمها.
            </Text>
          </div>
        )}
      </Paper>
    </Container>
  )
}

export default ValuesAndStrategiesTab
